export default "__VITE_ASSET__1596ca02__"